var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 457,
    viewBox: "0 0 457 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 228.295,
    cy: 228.295,
    r: 228.295,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 176.039,
    y: 409.33,
    width: 7.24179,
    height: 16.9087,
    transform: "rotate(15 176.039 409.33)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 277.934,
    y: 29.0532,
    width: 7.24179,
    height: 16.9087,
    transform: "rotate(15 277.934 29.0532)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.3862,
    y: 273.557,
    width: 7.24179,
    height: 16.9087,
    transform: "rotate(75 45.3862 273.557)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 425.664,
    y: 171.662,
    width: 7.24179,
    height: 16.9087,
    transform: "rotate(75 425.664 171.662)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6423,
    y: 92.522,
    width: 7.24179,
    height: 16.9087,
    transform: "rotate(135 97.6423 92.522)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 193.363,
    y: 23.4768,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    fill: "#1E2A41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 193.363,
    y: 387.385,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    fill: "#1E2A41"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 300.451,
    y: 33.4507,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(30 300.451 33.4507)",
    fill: "#1E2A41"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 118.498,
    y: 348.604,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(30 118.498 348.604)",
    fill: "#1E2A41"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 388.206,
    y: 95.6331,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(60 388.206 95.6331)",
    fill: "#1E2A41"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 73.0525,
    y: 277.587,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(60 73.0525 277.587)",
    fill: "#1E2A41"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 433.113,
    y: 193.362,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(90 433.113 193.362)",
    fill: "#1E2A41"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 69.2053,
    y: 193.362,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(90 69.2053 193.362)",
    fill: "#1E2A41"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 423.139,
    y: 300.451,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(120 423.139 300.451)",
    fill: "#1E2A41"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 107.986,
    y: 118.497,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(120 107.986 118.497)",
    fill: "#1E2A41"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 360.957,
    y: 388.206,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(150 360.957 388.206)",
    fill: "#1E2A41"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 179.003,
    y: 73.0527,
    width: 69.866,
    height: 45.7284,
    rx: 9.09219,
    transform: "rotate(150 179.003 73.0527)",
    fill: "#1E2A41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscs);
export default __webpack_public_path__ + "static/media/discs.24c7bb84e8b6314a05530899062c0439.svg";
export { ForwardRef as ReactComponent };